import { useMutation, useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IUncategorizedTransactions } from '../../types';

export const useGetUncategorizedData = ({
  customerId,
  q,
  onSuccess,
}: {
  customerId: string;
  q: string;
  onSuccess?: (data: IUncategorizedTransactions) => void;
}) =>
  useQuery(
    `useGetUncategorizedData-${customerId}-${q}`,
    async () => {
      if (!customerId || !q || q.length < 2) {
        return null;
      }
      const { data } = await httpService.get(`${BASE_URL}/api/v3/user/${customerId}/home/uncategorized?${q}`);
      return data;
    },
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 1000,
      retry: 2,
      refetchOnWindowFocus: false,
      onSuccess: (data: IUncategorizedTransactions) => {
        if (onSuccess) onSuccess(data);
      },
    },
  );

interface IPropsRemote {
  q: string;
  customerId: string;
}

export const useGetUncategorizedTotalNumOfRecords = () =>
  useMutation('GetUncategorizedDataRemote', async ({ q, customerId }: IPropsRemote) => {
    if (!customerId || !q || q.length < 2) {
      return null;
    }
    const { data } = await httpService.get(`${BASE_URL}/api/v3/user/${customerId}/home/uncategorized?${q}`);
    return data?.uncategorizedTotalNumOfRecords || 0;
  });
